define('modules/page_listing/models/page_update',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Model.extend({
    url: function(){
      return [config.apiHost, "pages", this.pageId, "pub"].join("/");
    },
    initialize: function(attrs,options){
      this.pageId = options.pageId;
    }
  });
});
